import { useEffect, useState, type ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useAuthStore } from '@/hooks/useAuthStore'
import { clinicalSessionScope } from '@/lib/clinicalSession'

function SessionQueries({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient({
    defaultOptions: {
      queries: { staleTime: 5 * 60 * 1000, retry: 1, refetchOnWindowFocus: false },
    },
  }))

  useEffect(() => () => {
    void client.cancelQueries()
    client.clear()
  }, [client])

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}

/** A clinic/user change discards both server cache and mounted clinical forms. */
export function ClinicalSessionProvider({ children }: { children: ReactNode }) {
  const userId = useAuthStore((state) => state.user?.id)
  const clinicId = useAuthStore((state) => state.activeClinicId)
  return <SessionQueries key={clinicalSessionScope(userId, clinicId)}>{children}</SessionQueries>
}
